export function encode(string) {
    return import.meta.server
        ? Buffer.from(string).toString('base64')
        : window.btoa(string);
}

export function encodeJSON(object) {
    const jsonString = JSON.stringify(object);

    return import.meta.server
        ? Buffer.from(jsonString).toString('base64')
        : window.btoa(jsonString);
}

export function decode(string) {
    return import.meta.server
        ? Buffer.from(string, 'base64').toString('utf8')
        : window.atob(string);
}

export function decodeJSON(string) {
    return import.meta.server
        ? JSON.parse(Buffer.from(string, 'base64').toString('utf8'))
        : JSON.parse(window.atob(string));
}
